import Vue from "vue";
import numeral from "numeral";

Vue.filter("formatNumber", function(value: string, format: string | undefined) {
  var number = numeral(value);
  return format ? number.format(format) : number.toString();
});
